const DEVICE_ID_KEY = 'escala-medica-device-id'

let deviceIdEmMemoria = null

export function getOrCreateDeviceId() {
    if (deviceIdEmMemoria) {
        return deviceIdEmMemoria
    }

    try {
        const armazenado = localStorage.getItem(DEVICE_ID_KEY)

        if (armazenado) {
            deviceIdEmMemoria = armazenado
            return deviceIdEmMemoria
        }

        deviceIdEmMemoria = gerarUuid()
        localStorage.setItem(DEVICE_ID_KEY, deviceIdEmMemoria)

        return deviceIdEmMemoria
    } catch {
        deviceIdEmMemoria = gerarUuid()
        return deviceIdEmMemoria
    }
}

function gerarUuid() {
    if (
        typeof crypto !== 'undefined' &&
        typeof crypto.randomUUID === 'function'
    ) {
        return crypto.randomUUID()
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        caractere => {
            const aleatorio = Math.random() * 16 | 0
            const valor = caractere === 'x'
                ? aleatorio
                : (aleatorio & 0x3) | 0x8

            return valor.toString(16)
        }
    )
}